import { render, staticRenderFns } from "./TutorialsList.vue?vue&type=template&id=70742f76&"
import script from "./TutorialsList.vue?vue&type=script&lang=js&"
export * from "./TutorialsList.vue?vue&type=script&lang=js&"
import style0 from "./TutorialsList.vue?vue&type=style&index=0&id=70742f76&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports